module.exports = __webpack_public_path__ + "static/media/invite-friends.58361216.svg";